"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ButtonUploadExcel = _interopRequireDefault(require("@/components/ButtonUploadExcel"));
var _ProjectRechargeRecordConfirm = _interopRequireDefault(require("./components/ProjectRechargeRecordConfirm.vue"));
var _componentsApi = require("@/api/componentsApi");
var _api = require("../api");
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    ButtonUploadExcel: _ButtonUploadExcel.default,
    ProjectRechargeRecordConfirm: _ProjectRechargeRecordConfirm.default
  },
  props: {
    companies: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      title: '批量发放',
      uploadFileName: '',
      // 上传文件名（展示用）
      uploadFile: null,
      // 原始上传文件对象
      form: {
        addCustomerEmpList: [],
        cardTimeRange: [],
        // 福卡有效期
        validStartTime: '',
        validEndTime: '',
        orderType: 1,
        // 福卡类型默认福卡充值
        exeType: '1',
        // 默认立即发放
        exeTime: '',
        // 预约发放时间
        projectNumber: '',
        // 项目编号
        applicationNumber: '',
        // 申请编号
        innerCompanyName: '',
        // 公司名称
        salesPrice: 0,
        // 销售总价（仅展示用）
        sendType: 4,
        // 发卡类型，默认出单卡
        issueQuantity: 0,
        // 发放数量
        //福卡面值
        integral: 0,
        //销售单价
        unitSalesPrice: 0,
        //原因
        reason: '',
        remark: '',
        // 内部备注
        innerRemark: '' // 备注
      },
      fdata: {},
      brandOption: [],
      sendTypeOptions: [{
        value: 1,
        label: '测试卡'
      }, {
        value: 2,
        label: '体验卡'
      }, {
        value: 3,
        label: '内部员工卡'
      }, {
        value: 4,
        label: '出单卡'
      }, {
        value: 5,
        label: '赠送'
      }, {
        value: 7,
        label: '客户充值'
      }, {
        value: 6,
        label: '其他'
      }],
      selectedCard: null,
      // 选中的福卡信息
      submitting: false,
      // 防止重复提交标志
      formRules: {
        companyId: [{
          required: true,
          message: '请选择公司',
          trigger: 'change'
        }],
        salesPrice: [{
          required: true,
          message: '销售总价不能为空',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '销售总价不能小于0',
          trigger: 'blur'
        }],
        totalFaceValue: [{
          required: true,
          message: '发放总面值不能为空',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '发放总面值不能小于0',
          trigger: 'blur'
        }],
        cardTimeRange: [{
          required: true,
          message: '请选择福卡有效期',
          trigger: 'change'
        }, {
          type: 'array',
          len: 2,
          message: '请选择完整的时间范围',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    projectNumberRules: function projectNumberRules() {
      return [{
        required: Number(this.form.sendType) === 4,
        message: '请输入项目编号',
        trigger: 'blur'
      }];
    },
    companyOptions: function companyOptions() {
      return (this.companies || []).map(function (item) {
        return {
          id: item.id,
          name: item.name || ''
        };
      }).filter(function (item) {
        return item.name;
      });
    }
  },
  watch: {
    // 监听销售单价和发放数量变化，自动计算销售总价
    'form.unitSalesPrice': {
      handler: function handler(newValue) {
        this.calculateSalesPrice();
      },
      immediate: true
    },
    'form.issueQuantity': {
      handler: function handler(newValue) {
        this.calculateSalesPrice();
      },
      immediate: true
    },
    // 监听员工列表变化，更新发放数量
    'form.addCustomerEmpList': {
      handler: function handler(newValue) {
        if (Array.isArray(newValue)) {
          this.form.issueQuantity = newValue.length;
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.searchBrand('');
  },
  methods: {
    open: function open(data) {
      this.fdata = data;
      this.title = (data === null || data === void 0 ? void 0 : data.customerName) || '批量发放';
      this.dialogFormVisible = true;
      this.setDefaultCardTimeRange();
    },
    close: function close() {
      this.form = {
        addCustomerEmpList: [],
        cardTimeRange: [],
        validStartTime: '',
        validEndTime: '',
        orderType: 1,
        exeType: '1',
        exeTime: '',
        projectNumber: '',
        applicationNumber: '',
        innerCompanyName: '',
        salesPrice: 0,
        totalFaceValue: 0,
        //发放总面值
        sendType: 4,
        // 默认出单卡
        issueQuantity: 0,
        //原因
        reason: '',
        //福卡面值
        integral: 0,
        //福卡Id
        fuCardId: '',
        //销售单价
        unitSalesPrice: 0,
        //不同面值的新增固定为2用户后端标识
        addType: 2,
        remark: '',
        // 内部备注
        innerRemark: '' // 备注
      };
      this.selectedCard = null;
      this.uploadFileName = '';
      this.uploadFile = null; // 清空原始文件
      this.dialogFormVisible = false;
    },
    download: function () {
      var _download = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _componentsApi.excelTemplateApi)('new_import_emp.xlsx');
            case 1:
              res = _context.v;
              window.open(res.fileName);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function download() {
        return _download.apply(this, arguments);
      }
      return download;
    }(),
    // 上传文件
    onSuccess: function onSuccess(excelData) {
      var _this = this;
      var results = excelData.results;
      console.log("excelData>>>>>>", excelData);
      // 记录文件名（兼容不同字段）
      this.uploadFileName = excelData.fileName || '';
      var arr = [];
      var _iterator = _createForOfIteratorHelper(results.entries()),
        _step;
      try {
        var _loop = function _loop() {
            var _step$value = _slicedToArray(_step.value, 2),
              index = _step$value[0],
              item = _step$value[1];
            var values = Object.values(item);
            // 校验必填列：0 姓名、1 手机、8 福卡面值、9 销售单价、10 福卡ID 11 发放原因
            var requiredIndexes = [0, 1, 8, 9, 10, 11];
            var missingIndex = requiredIndexes.find(function (idx) {
              return values[idx] === undefined || values[idx] === null || values[idx] === '';
            });
            if (missingIndex !== undefined) {
              _this.$message.error("\u5BFC\u5165\u5931\u8D25\uFF1A\u7B2C".concat(index + 1, "\u884C\u7B2C").concat(missingIndex + 1, "\u5217\u4E0D\u80FD\u4E3A\u7A7A"));
              return {
                v: void 0
              };
            }
            arr.push({
              empName: values[0],
              phone: values[1],
              empNo: values[2],
              wechat: values[3],
              dept: values[4],
              title: values[5],
              // 以下字段仅存在于每个员工条目中，不再映射到表单顶层
              integral: values[8],
              // 福卡面值
              unitSalesPrice: values[9],
              // 销售单价
              fuCardId: values[10],
              // 选择卡片
              reason: values[11] // 发放原因
            });
          },
          _ret;
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _ret = _loop();
          if (_ret) return _ret.v;
        }
        // 计算销售总价
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.form.salesPrice = arr.reduce(function (total, item) {
        var price = parseFloat(item.unitSalesPrice);
        return total + (isNaN(price) ? 0 : price);
      }, 0);
      console.log(this.form.salesPrice, "销售总价>>>>");

      //计算总面值
      this.form.totalFaceValue = arr.reduce(function (total, item) {
        var price = parseFloat(item.integral);
        return total + (isNaN(price) ? 0 : price);
      }, 0);
      console.log(this.form.totalFaceValue, "总面值>>>>");
      this.form.addCustomerEmpList = arr;
      this.form.issueQuantity = arr.length;
      console.log("this.form.addCustomerEmpList>>>>>>", this.form.addCustomerEmpList);
      this.$message.success('导入成功');
    },
    // 获取原始上传文件
    handleFileObject: function handleFileObject(rawFile) {
      console.log('原始文件对象:', rawFile);
      this.uploadFile = rawFile;
    },
    // 清除上传的文件
    clearUploadFile: function clearUploadFile() {
      this.uploadFileName = '';
      this.uploadFile = null; // 清空原始文件
      this.form.addCustomerEmpList = [];
      this.form.issueQuantity = 0;
      this.form.salesPrice = 0;
      this.$message.success('已清除上传文件');
    },
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var isValid, _this$form, addCustomerEmpList, cardTimeRange, validStartTime, validEndTime, exeType, exeTime, projectNumber, applicationNumber, innerCompanyName, companyId, salesPrice, sendType, issueQuantity, orderType, reason, integral, fuCardId, unitSalesPrice, addType, remark, innerRemark, params, groupedList, confirmed;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.submitting) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return this.validateFormRules();
            case 2:
              isValid = _context2.v;
              if (isValid) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              if (this.validateForm()) {
                _context2.n = 4;
                break;
              }
              return _context2.a(2);
            case 4:
              this.submitting = true;

              // 构建基础参数（不再传递顶部的福卡面值、单价、卡片等字段，只保留与批次本身相关的信息）
              _this$form = this.form, addCustomerEmpList = _this$form.addCustomerEmpList, cardTimeRange = _this$form.cardTimeRange, validStartTime = _this$form.validStartTime, validEndTime = _this$form.validEndTime, exeType = _this$form.exeType, exeTime = _this$form.exeTime, projectNumber = _this$form.projectNumber, applicationNumber = _this$form.applicationNumber, innerCompanyName = _this$form.innerCompanyName, companyId = _this$form.companyId, salesPrice = _this$form.salesPrice, sendType = _this$form.sendType, issueQuantity = _this$form.issueQuantity, orderType = _this$form.orderType, reason = _this$form.reason, integral = _this$form.integral, fuCardId = _this$form.fuCardId, unitSalesPrice = _this$form.unitSalesPrice, addType = _this$form.addType, remark = _this$form.remark, innerRemark = _this$form.innerRemark;
              params = _objectSpread(_objectSpread({
                addCustomerEmpList: addCustomerEmpList,
                cardTimeRange: cardTimeRange,
                validStartTime: validStartTime || cardTimeRange && cardTimeRange[0],
                validEndTime: validEndTime || cardTimeRange && cardTimeRange[1],
                exeType: exeType,
                exeTime: exeTime,
                projectNumber: projectNumber || '',
                innerCompanyName: innerCompanyName || '',
                companyId: companyId || '',
                salesPrice: salesPrice || 0,
                sendType: sendType || 4,
                issueQuantity: issueQuantity || 1,
                orderType: orderType || 1
              }, this.fdata), {}, {
                type: 1,
                // 发放类型
                customerIntegralId: this.fdata.id,
                applicationNumber: applicationNumber || '',
                // 申请编号

                //原因
                reason: reason || '',
                //福卡面值
                integral: integral || 0,
                //福卡Id
                fuCardId: fuCardId || '',
                //销售单价
                unitSalesPrice: unitSalesPrice || 0,
                addType: addType || 2,
                remark: remark || '',
                // 内部备注
                innerRemark: innerRemark || '' // 备注
              });
              params.customerEmpType = 3; // 批量发放固定为3
              // 保留兼容性，旧字段dueTime使用validEndTime
              params.dueTime = params.validEndTime;
              groupedList = this.groupCustomerEmpList(params.addCustomerEmpList);
              params.addCustomerEmpList = groupedList;

              //强制将发卡数量重置为0为了后端方面计算不同面值的总额
              params.issueQuantity = 0;

              // 批量发放必须上传文件，使用 FormData
              if (this.uploadFile) {
                _context2.n = 5;
                break;
              }
              this.$message.error('请先上传Excel文件');
              this.submitting = false;
              return _context2.a(2);
            case 5:
              _context2.n = 6;
              return this.confirmProjectRechargeRecord(params);
            case 6:
              confirmed = _context2.v;
              if (confirmed) {
                _context2.n = 7;
                break;
              }
              this.submitting = false;
              return _context2.a(2);
            case 7:
              this.submitWithFile(params);
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    confirmProjectRechargeRecord: function () {
      var _confirmProjectRechargeRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(params) {
        var projectNumber;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              projectNumber = String(params.projectNumber || '').trim();
              if (!(!projectNumber || Number(params.sendType) !== 4)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, true);
            case 1:
              if (this.$refs.projectRechargeRecordConfirmRef) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, true);
            case 2:
              return _context3.a(2, this.$refs.projectRechargeRecordConfirmRef.open({
                projectNumber: projectNumber
              }));
          }
        }, _callee3, this);
      }));
      function confirmProjectRechargeRecord(_x) {
        return _confirmProjectRechargeRecord.apply(this, arguments);
      }
      return confirmProjectRechargeRecord;
    }(),
    // 带文件上传的提交方法
    submitWithFile: function submitWithFile(params) {
      var formData = new FormData();

      // 后端使用 @RequestPart("data") 接收 JSON 数据
      var jsonBlob = new Blob([JSON.stringify(params)], {
        type: 'application/json'
      });
      formData.append('data', jsonBlob);

      // 后端使用 @RequestPart("file") 接收文件
      formData.append('file', this.uploadFile);

      // 使用文件上传 API
      this.request(_api.integralLogSaveWithFileApi, formData);
    },
    // 将 integral、unitSalesPrice、fuCardId、reason 相同的员工分为一组，返回二维数组
    groupCustomerEmpList: function groupCustomerEmpList(list) {
      if (!Array.isArray(list) || list.length === 0) {
        return [];
      }
      var map = {};
      list.forEach(function (item) {
        // 使用四个关键字段生成分组 key
        var key = [item.integral, item.unitSalesPrice, item.fuCardId, item.reason].join('||');
        if (!map[key]) {
          map[key] = [];
        }
        map[key].push(item);
      });

      // 返回二维数组，每一项都是一组相同配置的员工列表
      return Object.values(map);
    },
    searchBrand: function searchBrand() {
      var _this2 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      fudouActiveApi.selectCard(keyword).then(function (res) {
        _this2.brandOption = res || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this3 = this;
      this.throttle(function () {
        _this3.searchBrand(data);
      }, 300)();
    },
    changeBrand: function changeBrand(cardId) {
      if (!cardId) {
        this.searchBrand('');
        this.selectedCard = null;
        return;
      }
      this.selectedCard = this.brandOption.find(function (item) {
        return item.id === cardId;
      }) || null;
    },
    // 更新福卡有效期
    updateCardTimeRange: function updateCardTimeRange(val) {
      if (val && val.length === 2) {
        this.form.validStartTime = val[0];
        this.form.validEndTime = val[1];
      } else {
        this.form.validStartTime = '';
        this.form.validEndTime = '';
      }
    },
    setDefaultCardTimeRange: function setDefaultCardTimeRange() {
      var pad = function pad(n) {
        return n < 10 ? "0".concat(n) : "".concat(n);
      };
      var format = function format(date) {
        var y = date.getFullYear();
        var m = pad(date.getMonth() + 1);
        var d = pad(date.getDate());
        var hh = pad(date.getHours());
        var mm = pad(date.getMinutes());
        var ss = pad(date.getSeconds());
        return "".concat(y, "-").concat(m, "-").concat(d, " ").concat(hh, ":").concat(mm, ":").concat(ss);
      };
      var now = new Date();
      var end = new Date(now);
      end.setFullYear(end.getFullYear() + 3);
      var startStr = format(now);
      var endStr = format(end);
      this.form.cardTimeRange = [startStr, endStr];
      this.form.validStartTime = startStr;
      this.form.validEndTime = endStr;
    },
    throttle: function throttle(fn, delay) {
      var timer = null;
      return function () {
        if (timer) {
          return;
        }
        var args = arguments;
        var context = this;
        timer = setTimeout(function () {
          fn.apply(context, args);
          timer = null;
        }, delay);
      };
    },
    calculateSalesPrice: function calculateSalesPrice() {
      // 销售总价可根据上传的明细自行统计，这里不再强制计算，保持为只读展示字段
      // 如需统计，可在此遍历 addCustomerEmpList 中的单价和数量进行累加
    },
    // 表单规则验证
    validateFormRules: function () {
      var _validateFormRules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return this.$refs.formRef.validate();
            case 1:
              return _context4.a(2, true);
            case 2:
              _context4.p = 2;
              _t2 = _context4.v;
              console.log('表单验证失败:', _t2);
              return _context4.a(2, false);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function validateFormRules() {
        return _validateFormRules.apply(this, arguments);
      }
      return validateFormRules;
    }(),
    validateForm: function validateForm() {
      if (!this.form.sendType) {
        this.$message.error('请选择发卡类型');
        return false;
      }
      if (!this.form.issueQuantity || this.form.issueQuantity < 1) {
        this.$message.error('发放人数不能为0,请选择发放方式');
        return false;
      }
      return true;
    },
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(api, params) {
        var _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return api(params);
            case 1:
              this.$message.success('发放成功');
              this.close();
              this.$emit('refresh');
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t3 = _context5.v;
              this.$message.error(_t3);
            case 3:
              _context5.p = 3;
              this.submitting = false;
              return _context5.f(3);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2, 3, 4]]);
      }));
      function request(_x2, _x3) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }
};